import React, { useState } from "react";
import { CalendarDays, X } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

const toISO = (d) => (d ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}` : "");
const parse = (s) => { if (!s) return undefined; const [y, m, d] = s.split("-").map(Number); return new Date(y, m - 1, d); };
const fmt = (s) => (s ? parse(s).toLocaleDateString(undefined, { month: "short", day: "numeric" }) : "");

export function DateRangePicker({ from, to, onChange, placeholder = "Date range", testId, className }) {
  const [open, setOpen] = useState(false);
  const range = { from: parse(from), to: parse(to) };
  const label = from ? (to && to !== from ? `${fmt(from)} – ${fmt(to)}` : fmt(from)) : placeholder;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId}
          data-enter-submit=""
          className={cn("flex h-9 w-full items-center gap-2 rounded-lg border border-white/[0.1] bg-[#0A0A0A] px-3 text-sm outline-none focus:border-white/25",
            from ? "text-foreground" : "text-muted-foreground", className)}>
          <CalendarDays className="h-3.5 w-3.5 shrink-0" />
          <span className="truncate">{label}</span>
          {from && (
            <X className="ml-auto h-3.5 w-3.5 shrink-0 hover:text-foreground"
              onClick={(e) => { e.stopPropagation(); onChange({ from: "", to: "" }); }} />
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto border-white/[0.1] bg-[#141417] p-0" data-testid={`${testId}-popover`}>
        <Calendar mode="range" numberOfMonths={2} selected={range} defaultMonth={range.from}
          onSelect={(r) => {
            const f = toISO(r?.from);
            const t = toISO(r?.to);
            onChange({ from: f, to: t });
            if (r?.from && r?.to) setOpen(false);
          }} />
      </PopoverContent>
    </Popover>
  );
}
